module.exports = __webpack_public_path__ + "static/food_poverty-eb8e26ef161632e84f06a71d1a4ecbb7.jpg";